import { defineStore } from 'pinia'

import { StoreState } from '@shared/models/interfaces/store'
import { resourcePath } from '@shared/plugins/api'
import { ApiTransport } from '@shared/plugins/api-transport'
import {
  getInitialState,
  updateState,
} from '@shared/utils/store/http-request-state'

import { UserPreferences } from '@protos/apps/vc/user_preferences_pb'

import { IUserPreferences } from '@vc/models/proto/base/user-preferences'
import { UserPreferencesUpdateDTO } from '@vc/models/proto/dto/user-preferences'
import { UserPreferencesRO } from '@vc/models/proto/ro/user-preferences'

interface State {
  userPreferences: StoreState<UserPreferences>
  isNotificationMuted: boolean
}

const state: () => State = () => ({
  userPreferences: getInitialState(),
  isNotificationMuted: false,
})

export const apiTransport = new ApiTransport(resourcePath, 'vc')

export const useUserPreferencesStore = defineStore({
  id: 'user-preferences',

  state,

  actions: {
    async fetchUserPreferences() {
      this.userPreferences = updateState(this.userPreferences)

      try {
        const { data } =
          await apiTransport.getWithoutRequest<UserPreferencesRO>(
            '/user_preferences',
            UserPreferencesRO
          )

        this.userPreferences = updateState(this.userPreferences, data)
        this.isNotificationMuted = !!data?.shouldMuteVirtualConversationsChime
        return data
      } catch (error) {
        this.userPreferences = updateState(
          this.userPreferences,
          new Error(`${error}`)
        )
      }
    },

    async updateUserPreferences(payload: { data: IUserPreferences }) {
      try {
        const { data } = (await apiTransport.put<
          UserPreferencesUpdateDTO,
          UserPreferencesRO
        >(
          '/user_preferences',
          new UserPreferencesUpdateDTO(payload),
          UserPreferencesUpdateDTO,
          UserPreferencesRO
        )) ?? { data: {} }

        this.isNotificationMuted = !!data?.shouldMuteVirtualConversationsChime

        this.userPreferences = updateState(this.userPreferences, data)

        return data
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
})
